import { render, staticRenderFns } from "./OrderCreatorService.vue?vue&type=template&id=0cb8c914&scoped=true&"
import script from "./OrderCreatorService.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorService.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorService.vue?vue&type=style&index=0&id=0cb8c914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb8c914",
  null
  
)

export default component.exports